import React from 'react';
import { fmt, PARTY_STATUS_CONFIG } from '../../../../helper/storeQuotation';

const ComparativeTable = ({ quotation }) => {

  if (!quotation) return (
    <div className="text-center py-5 border rounded-3 bg-light">
      <i className="fa fa-info-circle fa-3x text-muted mb-3"></i>
      <p className="text-muted mb-0">No data available</p>
    </div>
  );

  const parties = quotation.party_columns || quotation.parties?.map(p => {
    const pId = typeof p.party_id === 'object' && p.party_id !== null ? p.party_id?._id : p.party_id;
    return {
      party_id: pId,
      name: p.party_snapshot?.name || p.party_id?.name || 'Unknown',
      phone: p.party_snapshot?.phone || p.party_id?.phone || '',
      party_status: p.party_status,
      is_finalized: p.is_finalized,
      amount: p.total_amount,
      total_gst: p.total_gst,
      loading_charge: p.loading_charge,
      total_payable: p.total_payable,
      delivery_terms: p.delivery_terms,
      payment_terms: p.payment_terms
    };
  }) || [];

  const items = quotation.rows || quotation.items?.map((item, idx) => {
    const party_columns = {};
    item.party_rates?.forEach(r => {
      const pId = typeof r.party_id === 'object' ? r.party_id?._id : r.party_id;
      if (pId) {
        party_columns[pId] = {
          rate: r.rate,
          amount: r.amount,
          net_amount: r.net_amount,
          is_finalized: r.is_finalized,
          make: r.make,
          remark: r.remark
        };
      }
    });

    return {
      _id: item._id,
      item_id: item.item_id,
      item_name: item.item_name,
      size: item.size,
      quantity: item.quantity,
      finalized_party_id: item.finalized_party_id,
      party_columns
    };
  }) || [];

  if (!parties?.length) return (
    <div className="text-center py-5 border rounded-3 bg-light">
      <i className="fa fa-users fa-3x text-muted mb-3"></i>
      <p className="text-muted mb-0">No parties added yet. Use "Send to Parties" to add suppliers.</p>
    </div>
  );

  if (!items?.length) return (
    <div className="text-center py-5 border rounded-3 bg-light">
      <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
      <p className="text-muted mb-0">No items in this quotation</p>
    </div>
  );

  return (
    <div className="table-responsive">
      <table className="table table-bordered comman-table mb-0">
        <thead className="">
          <tr>
            <th colSpan={4} className=""></th>
            {parties?.map(p => (
              <th key={p.party_id} colSpan={2} className="text-center " style={{
                minWidth: '200px',
                backgroundColor: p.is_finalized ? 'rgba(52, 211, 153, 0.05)' : 'rgba(250, 163, 96, 0.05)',
                color: p.is_finalized ? '#34d399' : '#ff6923'
              }}>
                <div className="fw-bold" style={{ fontSize: "15px" }}>{p?.name || "-"}</div>
                <div className="text-muted fw-normal" style={{ fontSize: "12px" }}>{p?.phone || "-"}</div>
                <div className="mt-1">
                  <span className="px-3 py-1 rounded-2" style={{
                    backgroundColor: `${PARTY_STATUS_CONFIG[p.party_status]?.color}22`,
                    color: PARTY_STATUS_CONFIG[p.party_status]?.color,
                    fontSize: '12px',
                    letterSpacing: "0.7px"
                  }}>
                    {PARTY_STATUS_CONFIG[p.party_status]?.label}
                  </span>
                </div>
              </th>
            ))}
          </tr>
          <tr className=''>
            <th className="text-center  small fw-bold">#</th>
            <th className="small  fw-bold">Description</th>
            <th className="small  fw-bold">Size</th>
            <th className="small  fw-bold text-center">Qty</th>
            {parties?.map(p => (
              <React.Fragment key={p.party_id}>
                <th className="small fw-bold  text-center ">Price (₹)</th>
                <th className="small fw-bold  text-center ">Amount (₹)</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => {
            const partyColumnsObj = item.party_columns || {};
            const amounts = Object.values(partyColumnsObj)
              .map(r => r.amount)
              .filter(Boolean);
            const minAmt = amounts.length ? Math.min(...amounts) : null;

            return (
              <tr key={item._id || item.item_id || idx}>
                <td className="text-center  text-muted small">{item.sr_no || idx + 1}</td>
                <td className=''>
                  <div className="fw-semibold small text-dark text-nowrap">{item.item_name} {item.finalized_party_id && (
                    <span className="bg-success-light text-success px-3 py-1 rounded-3 ms-1" style={{ fontSize: '9px' }}>
                      ✓ Finalized
                    </span>
                  )}
                  </div>

                </td>
                <td className="text-muted small">{item.size || "-"}</td>
                <td className="text-center fw-bold">{fmt(item.quantity)}</td>
                {parties.map(p => {
                  const r = partyColumnsObj[p.party_id];
                  const isLowest = r && minAmt && r.amount === minAmt;
                  const isFinalized = r?.is_finalized;

                  return (
                    <React.Fragment key={p.party_id}>
                      <td className={`text-center small ${isFinalized ? 'text-success fw-bold' : isLowest ? 'text-primary fw-bold' : ''}`} style={{ backgroundColor: isFinalized ? 'rgba(52, 211, 153, 0.05)' : '' }}>
                        <div>{r ? fmt(r.rate) : <span className="text-muted opacity-50">-</span>}</div>
                      </td>
                      <td className={`text-center small ${isFinalized ? 'text-success fw-bold' : isLowest ? 'text-primary fw-bold' : ''}`} style={{ backgroundColor: isFinalized ? 'rgba(52, 211, 153, 0.1)' : '' }}>
                        {r ? (
                          <span>
                            {fmt(r.amount)} {isFinalized && <span className="ms-1" style={{ fontSize: '13px', color: 'inherit' }}>✓</span>}
                            {isLowest && !isFinalized && <span className="ms-1" style={{ fontSize: '10px', color: 'inherit' }}>Low</span>}
                          </span>
                        ) : <span className="text-muted opacity-50">-</span>}
                      </td>
                    </React.Fragment>
                  );
                })}
              </tr>
            );
          })}
          <tr className=" fw-bold border-top-2">
            <td colSpan={4} className="text-end text-primary pe-3" style={{ fontWeight: "600" }}>Total</td>
            {parties.map(p => (
              <React.Fragment key={p.party_id}>
                <td className="border-start"></td>
                <td className={`text-center ${p.is_finalized ? 'text-success' : 'text-orange'}`} style={{ fontSize: '14px', fontWeight: "600" }}>
                  {fmt(p.amount) || "-"}
                </td>
              </React.Fragment>
            ))}
          </tr>
          <tr>
            <td colSpan={4} className="text-end small text-muted pe-3" style={{ fontWeight: "600" }}>GST</td>
            {parties.map(p => (
              <React.Fragment key={p.party_id}>
                <td className="border-start"></td>
                <td className="text-center small text-muted" style={{ fontWeight: "600" }}>{fmt(p.total_gst)}</td>
              </React.Fragment>
            ))}
          </tr>
          <tr>
            <td colSpan={4} className="text-end small text-muted pe-3" style={{ fontWeight: "600" }}>Loading Charges</td>
            {parties.map(p => (
              <React.Fragment key={p.party_id}>
                <td className="border-start"></td>
                <td className="text-center small text-muted" style={{ fontWeight: "600" }}>{fmt(p.loading_charge)}</td>
              </React.Fragment>
            ))}
          </tr>
          {/* <tr className="fw-bold bg-light">
            <td colSpan={4} className="text-end text-success pe-3" style={{ fontWeight: "600" }}>Net Total</td>
            {parties.map(p => (
              <React.Fragment key={p.party_id}>
                <td className="border-start"></td>
                <td className="text-center text-success" style={{ fontSize: '15px', fontWeight: "600" }}>
                  {fmt(p.total_net_amount || (p.amount + p.total_gst))}
                </td>
              </React.Fragment>
            ))}
          </tr> */}
          <tr className="fw-bold bg-light">
            <td colSpan={4} className="text-end text-success pe-3" style={{ fontWeight: "600" }}>Net Total</td>
            {parties.map(p => {
              const amounts = parties.map(pt => pt.total_payable).filter(Boolean);
              const minPayable = amounts.length ? Math.min(...amounts) : null;
              const isLowest = minPayable && p.total_payable === minPayable;

              return (
                <React.Fragment key={p.party_id}>
                  <td className="border-start"></td>
                  <td className="text-center text-success" style={{ fontSize: '15px', fontWeight: "600" }}>
                    <span>
                      {fmt(p.total_payable)}
                      {isLowest && !p.is_finalized && <span className="ms-1" style={{ fontSize: '10px', color: 'inherit' }}>Low</span>}
                    </span>
                  </td>
                </React.Fragment>
              );
            })}
          </tr>

          <tr>
            <td colSpan={4} className="text-end small text-muted pe-3" style={{ fontWeight: "600" }}>Delivery Terms</td>
            {parties.map(p => (
              <td key={p.party_id} colSpan={2} className="text-center small text-secondary italic">
                {p.delivery_terms || "-"}
              </td>
            ))}
          </tr>
          <tr>
            <td colSpan={4} className="text-end small text-muted pe-3" style={{ fontWeight: "600" }}>Payment Terms</td>
            {parties.map(p => (
              <td key={p.party_id} colSpan={2} className="text-center small text-secondary italic">
                {p.payment_terms || "-"}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ComparativeTable;
